import { useEffect } from "react";

import { useLocation } from "react-router-dom";

const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: "spa_pageview",
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

export default PageViewTracker;
